module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}\nconst employeeID = employee.employeeID\nconst project = (resourceData.data || {}).attributes || {}\nconst customer = project.customer\nconst personInChargeEmployee = project.personInChargeEmployee\nconst terms = project.terms || []\nconst amIPartialManager = project.amIPartialManager || false\nconst isOfficeManager = helpers.hasRoleInScope('office')\nconst isManager = employee.isManager || isOfficeManager || false\nconst additionalAttributes = []\nif(project.projectID){\nadditionalAttributes.push(`data-project-id=\"${project.projectID}\"`)\n}\n%><div <%- additionalAttributes.join(' ') %>><%\nif(!project.projectID){\n%><div class=\"empty\"><%\n%><%= storage.__('projects.crewViewer.common.projectNotFound') %><%\n%></div><%\n} else {\n%><div class=\"head\"><%\n%><h1><%= `#${project.projectID} - ${project.title || 'Projekt'}` %></h1><%\n%><div class=\"buttons\"><%\nif(isOfficeManager && !project.isInternal){\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'shippingOrders', symbolOnly: true }}) %><%\n%><%- include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'timeRecordings', symbolOnly: true }}) %><%\n}\n%></div><%\n%></div><%\nif(customer || (amIPartialManager && personInChargeEmployee)) {\n%><ul><%\nif(customer) {\n%><li><%\n%><%- include('./viewerField', { model: { company: customer, labelKey: 'projects.crewViewer.fields.customer.name', showDetails: isManager || amIPartialManager }}) %><%\n%></li><%\n}\nif(amIPartialManager && personInChargeEmployee) {\n%><li><%\n%><%- include('./viewerField', { model: { nicknamePerson: personInChargeEmployee, labelKey: 'projects.crewViewer.fields.personInChargeEmployee.name', showDetails: isManager || amIPartialManager }}) %><%\n%></li><%\n}\n%></ul><%\n}\n%><%- helpers.renderSection('projectTerms') %><%\n}\n%></div>"
  , __filename = "components/templates/crew/projects/viewer.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const employee = (((storage.user || {}).data || {}).userTableAssociates || {}).employee || {}
const employeeID = employee.employeeID
const project = (resourceData.data || {}).attributes || {}
const customer = project.customer
const personInChargeEmployee = project.personInChargeEmployee
const terms = project.terms || []
const amIPartialManager = project.amIPartialManager || false
const isOfficeManager = helpers.hasRoleInScope('office')
const isManager = employee.isManager || isOfficeManager || false
const additionalAttributes = []
if(project.projectID){
additionalAttributes.push(`data-project-id="${project.projectID}"`)
}

    ; __line = 15
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">")
    ; 
if(!project.projectID){

    ; __line = 17
    ; __append("<div class=\"empty\">")
    ; 

    ; __line = 18
    ; __append(escapeFn( storage.__('projects.crewViewer.common.projectNotFound') ))
    ; 

    ; __line = 19
    ; __append("</div>")
    ; 
} else {

    ; __line = 21
    ; __append("<div class=\"head\">")
    ; 

    ; __line = 22
    ; __append("<h1>")
    ; __append(escapeFn( `#${project.projectID} - ${project.title || 'Projekt'}` ))
    ; __append("</h1>")
    ; 

    ; __line = 23
    ; __append("<div class=\"buttons\">")
    ; 
if(isOfficeManager && !project.isInternal){

    ; __line = 25
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'shippingOrders', symbolOnly: true }}) )
    ; 

    ; __line = 26
    ; __append( include('../../core/form/elements/buttons/default', { formMapping: { buttonType: 'showEdit', context: 'timeRecordings', symbolOnly: true }}) )
    ; 
}

    ; __line = 28
    ; __append("</div>")
    ; 

    ; __line = 29
    ; __append("</div>")
    ; 
if(customer || (amIPartialManager && personInChargeEmployee)) {

    ; __line = 31
    ; __append("<ul>")
    ; 
if(customer) {

    ; __line = 33
    ; __append("<li>")
    ; 

    ; __line = 34
    ; __append( include('./viewerField', { model: { company: customer, labelKey: 'projects.crewViewer.fields.customer.name', showDetails: isManager || amIPartialManager }}) )
    ; 

    ; __line = 35
    ; __append("</li>")
    ; 
}
if(amIPartialManager && personInChargeEmployee) {

    ; __line = 38
    ; __append("<li>")
    ; 

    ; __line = 39
    ; __append( include('./viewerField', { model: { nicknamePerson: personInChargeEmployee, labelKey: 'projects.crewViewer.fields.personInChargeEmployee.name', showDetails: isManager || amIPartialManager }}) )
    ; 

    ; __line = 40
    ; __append("</li>")
    ; 
}

    ; __line = 42
    ; __append("</ul>")
    ; 
}

    ; __line = 44
    ; __append( helpers.renderSection('projectTerms') )
    ; 
}

    ; __line = 46
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/crew/projects/viewer.ejs

}